export const DatePickerFormat = 'yyyy/MM/dd';

export const dateOptions = [
  { k: 'today', v: '本日' },
  { k: 'yesterday', v: '昨日' },
  { k: 'this_month', v: '今月' },
  { k: 'last_month', v: '先月' }
];

export const formatDate = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}-${('0' + (d.getMonth() + 1)).slice(-2)}-${('0' + d.getDate()).slice(-2)}`;
};

export const getDateRange = (option) => {
  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterdayStart = new Date(todayStart);
  yesterdayStart.setDate(todayStart.getDate() - 1);

  switch (option) {
    case 'today':
      return {
        start: todayStart,
        end: new Date()
      };
    case 'yesterday':
      return {
        start: yesterdayStart,
        end: new Date(todayStart - 1)
      };
    case 'this_month':
      return {
        start: new Date(now.getFullYear(), now.getMonth(), 1),
        end: new Date()
      };
    case 'last_month':
      return {
        start: new Date(now.getFullYear(), now.getMonth() - 1, 1),
        end: new Date(now.getFullYear(), now.getMonth(), 0)
      };
    default:
      return {
        start: todayStart,
        end: new Date()
      };
  }
};
